<script setup lang="ts">
defineProps({
	minHeight: {
		type: Number,
		default: 240,
	},
});
</script>
<template>
	<div
		class="no-data"
		:style="{ minHeight: `${minHeight}px` }"
	>
		<div>
			<SearchIcon
				class="icon"
				width="24"
				height="24"
			/>
			<slot name="content" />
		</div>
		<slot name="action" />
	</div>
</template>
<style lang="scss" scoped>
.no-data {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: spacings-get(6);
	text-align: center;

	* {
		text-align: center;
	}

	:deep(h1) {
		color: colors-get(gray, 900);
	}

	:deep(p) {
		color: colors-get(gray, 600);
	}

	.icon {
		margin: spacings-get(3);
	}
}
</style>
